export const isValidObject = (item: unknown): boolean => {
  return !!item && typeof item === 'object' && !Array.isArray(item)
}

export const isValidDate = (date: unknown): boolean => {
  const formattedDate = date ? new Date(date as string | number | Date) : date
  return formattedDate instanceof Date && !isNaN(formattedDate.getTime())
}
